export default __webpack_public_path__ + "static/brand-5ff4ef2a5436164b9bf9b00d7a33475c.svg";